import { CancelTokenSource } from "axios";
import { CancellationTokenSource } from "../models/CancellationTokenSource";

export class AxiosCancellationTokenSource implements CancellationTokenSource {
    private readonly source: CancelTokenSource;

    constructor(source: CancelTokenSource) {
        this.source = source;
    }

    cancel = () => {
        this.source.cancel();
    };
}
